<div class="container-lg my-4 px-3 px-md-4 g-sm-3 g-md-4 g-lg-5 vstack gap-3">
    <ng-content></ng-content>
</div>
